import AuditsModalView from "./audits_modal.html";


angular.module("audits")

    .controller('AuditsListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', '$uibModal', 'uiGridConstants', '$filter', 'LoginService', '$state', function ($rootScope, $scope, Restangular, gridService, $uibModal, uiGridConstants, $filter, LoginService, $state) {

        $rootScope.title = $filter('translate')('audits.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('audits.list') }
        ];

        $scope.search = {
            username: "",
            action: "",
            table: "",
            date_from: null,
            date_to: null
        };


        $scope.gridOptionsAudits = {
            pdfTitle: $filter('translate')('audits.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [50, 100, 150],
            paginationPageSize: 50,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'created_at', displayName: $filter('translate')('audits.date'), enableFiltering: true, cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'', enableHiding: false, enableColumnMenu: false },
                { name: 'username', displayName: $filter('translate')('audits.username'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'action', displayName: $filter('translate')('audits.action'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'table_name', displayName: $filter('translate')('audits.table_name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'duration', displayName: $filter('translate')('audits.duration'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('audits.change'), action: 'ng-click="grid.appScope.openDialog(row.entity.changes);"', cssIconClass: "fa fa-eye" },
                        { title: $filter('translate')('audits.column_values'), action: 'ng-click="grid.appScope.openDialog(row.entity.column_values);"', cssIconClass: "fa fa-eye" }
                    ], { cssClass: "pull-right" })
                },

            ],
            getData: function (options) {
                options.username = $scope.search.username;
                options.action = $scope.search.action;
                options.table = $scope.search.table;
                options.date_from = $scope.search.date_from;
                options.date_to = $scope.search.date_to;

                return Restangular.all('Audits').getList(options);
            }
            
        };

        $scope.searchAudits = function () {
            if (angular.isDefined($scope.gridOptionsAudits.loadData)) {
                $scope.gridOptionsAudits.loadData(false);
            }
        }

        $scope.openDialog = function (value) {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: AuditsModalView,
                size: "lg", 
                controller: "AuditsModalCtrl",
                resolve: {
                    value: function () {return value}
                }
            });


        };
    }])

    .controller("AuditsModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'value', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, value) {

        $scope.value = value;

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])


;